import {assign} from 'xstate'
import ApiFetcher from 'lib/api_fetcher'
import moment from 'moment'
import {nextStep} from 'utils/step_utils'
import i18n from 'i18n/config'

const stepName  = 'languageStep'

const setEmptyError = assign({error: i18n.t('validations:language_selection_required')})
const setLanguage = assign({language: (ctx, e) => e.language.value})
const cleanError = assign({error: null})
const languageSelected = (ctx) => ctx.language

const languageState = (config) => {
  return {
    initial: 'init',
    states: {
      init: {
        on: {'': {
          target: 'waitingLanguageInput'
        }},
      },
      waitingLanguageInput: {
      },
    },
    on: {
      LANGUAGE_CHANGE: {
        actions: [setLanguage, cleanError]
      },
      NEXT_STEP_CLICK: [
        {
          target: nextStep(config, stepName),
          cond: languageSelected
        },
        {
          actions: [setEmptyError]
        }
      ]
    }
  }
}

export default languageState
